import { useState } from 'react';
import { createContainer } from 'unstated-next';

const AuthContainer = createContainer(() => {
  const [isLogin, setIsLogin] = useState<boolean>(false);

  return {
    isLogin,
    setIsLogin,
  };
});

export default AuthContainer;
